export const isTextHtml = (text) => {
    if (text && text[0] === '<' && text[text.length - 1] === '>') {
        return true;
    }
    return false;
};
